const serviceModules: Record<string, Record<string, unknown>> =
    import.meta.glob('./services/*Service.ts', { eager: true });

export const services: string[] = Object.values(serviceModules).flatMap(
    (mod) =>
        Object.entries(mod)
            .filter(([key]) => /^[a-z]/.test(key) && key.endsWith('Service'))
            .map(([, value]) => value as string),
);
